/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseAgentContextDocumentDto } from '../models/api-response-agent-context-document-dto';
import { ApiResponseListAgentContextDocumentDto } from '../models/api-response-list-agent-context-document-dto';
import { ApiResponseListString } from '../models/api-response-list-string';
import { listContextDocuments } from '../fn/agent-context-document-admin-api/list-context-documents';
import { ListContextDocuments$Params } from '../fn/agent-context-document-admin-api/list-context-documents';
import { listDocumentTypes } from '../fn/agent-context-document-admin-api/list-document-types';
import { ListDocumentTypes$Params } from '../fn/agent-context-document-admin-api/list-document-types';
import { upsertContextDocument } from '../fn/agent-context-document-admin-api/upsert-context-document';
import { UpsertContextDocument$Params } from '../fn/agent-context-document-admin-api/upsert-context-document';

@Injectable({ providedIn: 'root' })
export class AgentContextDocumentAdminApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `upsertContextDocument()` */
  static readonly UpsertContextDocumentPath = '/v1/api/admin-ui/agent-context/{companyId}/documents/{documentType}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `upsertContextDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertContextDocument$Response(params: UpsertContextDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAgentContextDocumentDto>> {
    return upsertContextDocument(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `upsertContextDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  upsertContextDocument(params: UpsertContextDocument$Params, context?: HttpContext): Observable<ApiResponseAgentContextDocumentDto> {
    return this.upsertContextDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAgentContextDocumentDto>): ApiResponseAgentContextDocumentDto => r.body)
    );
  }

  /** Path part for operation `listContextDocuments()` */
  static readonly ListContextDocumentsPath = '/v1/api/admin-ui/agent-context/{companyId}/documents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listContextDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  listContextDocuments$Response(params: ListContextDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAgentContextDocumentDto>> {
    return listContextDocuments(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listContextDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listContextDocuments(params: ListContextDocuments$Params, context?: HttpContext): Observable<ApiResponseListAgentContextDocumentDto> {
    return this.listContextDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListAgentContextDocumentDto>): ApiResponseListAgentContextDocumentDto => r.body)
    );
  }

  /** Path part for operation `listDocumentTypes()` */
  static readonly ListDocumentTypesPath = '/v1/api/admin-ui/agent-context/document-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listDocumentTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  listDocumentTypes$Response(params: ListDocumentTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListString>> {
    return listDocumentTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listDocumentTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listDocumentTypes(params: ListDocumentTypes$Params, context?: HttpContext): Observable<ApiResponseListString> {
    return this.listDocumentTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListString>): ApiResponseListString => r.body)
    );
  }

}
